import eventBus from "./eventBus";

export const getReactComponent = (setHtml) => {
  return class Main {
    constructor(model) {
      this.model = model;
      this.I18N = (key) => KDApi.getLangMsg(model, key);
    }
    init(props) {
      console.log("-----init", props);
      setHtml(this.model, props, { I18N: this.I18N });
    }
    update(props) {
      console.log("-----update", props);
      eventBus.pub(this.model, "update", props);
    }
    destoryed() {
      console.log("-----destoryed", this.model);
      ReactDOM.unmountComponentAtNode(this.model.dom);
    }
  };
};
